import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div style={{ color: "gray", fontSize: "14px", marginTop: "30px" }}>
      &copy; {currentYear} InvesTek.in. All rights reserved. Ver 2.0.0.
    </div>
  );
};

export default Footer;
